// extracted by mini-css-extract-plugin
module.exports = {"reveal":"Reveal_reveal__uRGB2","revealIn":"Reveal_revealIn__r0S7w","animation-section":"Reveal_animation-section__oR0ww"};